/*
 * @Author: luting
 * @Date: 2022-04-15 14:55:55
 * @lastEditors: luting
 * @LastEditTime: 2023-04-03 17:45:20
 */
import React from 'react';
import { Button, Tooltip } from 'sup-ui';
import { useNavigate } from 'react-router-dom';
import { useIntl } from 'react-intl';
import messages from '../messages';
import Icon from 'root/components/Icon';
import styles from './index.less';

interface IconfirmDiskFooter {
  // 公共 必传
  currentProgress: string;
  setCurrentProgress?: any;
  // 全新安装
  clickStartConfirmDisk?: () => void;
  clickRefershEvent?: () => void;
  setUpdateDiskConfig?: any;
  clickLastStepEvent?: () => void;
  clickPartitionEvent?: () => void;
  refershDataEvent?: () => void;
  deletePartition?: () => void;
  formatBlock?: () => void;

  // 非标参数
  disabled?: boolean;
  createSysPoint?: () => void; // 创建系统挂载点
}

const confirmDiskFooter: React.FC<IconfirmDiskFooter> = (props) => {
  const {
    currentProgress,
    clickStartConfirmDisk,
    clickRefershEvent,
    setUpdateDiskConfig,
    clickLastStepEvent,
    clickPartitionEvent,

    deletePartition,
    formatBlock,

    // 非标
    disabled,
  } = props;
  const intl = useIntl();
  const navigate = useNavigate();

  // 回退到主机检测
  const clickInstallSuposEvent = () => {
    navigate('/instances');
    // navigate('/envManage');
  };

  const btnData: any = {
    //  选择磁盘
    selectDisk: [
      {
        title: 'exit',
        className: 'serverSetBtn',
        callbake: clickInstallSuposEvent,
        position: 'left',
      },
      {
        title: 'nextStep',
        type: 'primary',
        className: 'serverSetPrimaryBtn',
        callbake: clickStartConfirmDisk,
        position: 'right',
      },
      {
        title: 'refersh',
        className: 'serverSetBtn',
        callbake: clickRefershEvent,
        position: 'right',
      },
    ],
    // 全新确认磁盘
    confirmDisk: [
      {
        title: 'exit',
        className: 'serverSetBtn',
        callbake: clickInstallSuposEvent,
        position: 'left',
      },
      {
        title: 'beginToPartition',
        type: 'primary',
        className: 'serverSetPrimaryBtn',
        callbake: clickPartitionEvent,
        position: 'right',
        disable: disabled,
      },
      {
        title: 'lastStep',
        className: 'serverSetBtn',
        position: 'right',
        callbake: clickLastStepEvent,
      },
      {
        title: 'changeDiskSet',
        className: 'serverSetBtn',
        position: 'right',
        callbake: () => {
          setUpdateDiskConfig(true);
        },
      },
    ],
    // 磁盘分区
    partitionDisk: [
      {
        title: 'exit',
        className: 'serverSetBtn',
        callbake: clickInstallSuposEvent,
        position: 'left',
        disable: true,
      },
      {
        title: 'installNow',
        position: 'right',
        type: 'primary',
        disable: true,
        className: 'serverSetPrimaryBtn',
      },
      { title: 'changeDiskSet', position: 'right', disable: true, className: 'serverSetBtn' },
    ],
    // 确认安装
    confirmInstall: [
      {
        title: 'installNow',
        type: 'primary',
        position: 'right',
        className: 'serverSetPrimaryBtn',
        callbake: clickInstallSuposEvent,
      },
      {
        title: 'changeDiskSet',
        className: 'serverSetBtn',
        position: 'left',
        callbake: formatBlock,
      },
    ],
    // 分区失败
    partitionFailed: [
      {
        title: 'exit',
        className: 'serverSetBtn',
        callbake: clickInstallSuposEvent,
        position: 'left',
        disable: true,
      },
      {
        title: 'formatting',
        type: 'primary',
        className: 'serverSetPrimaryBtn',
        callbake: deletePartition,
        position: 'right',
      },
      // {
      //   title: 'changeDiskSet',
      //   className: 'serverSetBtn',
      //   position: 'left',
      //   callbake: () => {
      //     setUpdateDiskConfig(true);
      //   },
      // },
    ],
  };

  return (
    <div className={styles.btnFooter}>
      <div className={styles.btnPosition}>
        {btnData[currentProgress]?.map((item: any) => (
          <div style={{ float: item.position }} key={item.title}>
            {item.title === 'createSystemMountPoint' && (
              <Tooltip defaultVisibled={true} title={intl.formatMessage(messages.createTip)}>
                <span>
                  &nbsp;
                  <Icon style={{ fontSize: 16 }} type="tip16" />
                  &nbsp;
                </span>
              </Tooltip>
            )}
            <Button onClick={item.callbake} className={styles[item.className]} disabled={item.disable} type={item.type}>
              {intl.formatMessage(messages[item.title])}
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default confirmDiskFooter;
